import { Container, Grid, Typography } from '@mui/material'
import { Box } from '@mui/system'
import React from 'react'
import TotalColecciones from './TotalColecciones'
import TotalUsuarios from './TotalUsuarios'
import UsuariosMes from './UsuariosMes'
import UsuariosUniversidad from './UsuariosUniversidad'

const Dashboard = () => {
    return (
        <>
            <Box
                component="main"
                sx={{
                    flexGrow: 1,
                    py: 8
                }}
            >
                <Container maxWidth={false}>
                    <Grid
                    container
                    spacing={3}
                    >
                        <Grid
                            item
                            lg={3}
                            sm={6}
                            xl={3}
                            xs={12}
                        >
                            <TotalUsuarios/>
                        </Grid>
                        <Grid
                            item
                            xl={3}
                            lg={3}
                            sm={6}
                            xs={12}
                        >
                            <UsuariosMes/>
                        </Grid>
                        <Grid
                            item
                            xl={3}
                            lg={3}
                            sm={6}
                            xs={12}
                        >
                            <TotalColecciones/>
                        </Grid>
                        <Grid
                            item
                            xl={3}
                            lg={3}
                            sm={6}
                            xs={12}
                        >
                            <UsuariosUniversidad/>
                        </Grid>
                    </Grid>
                </Container>
            </Box>
        </>
    )
}

export default Dashboard